import { FormControl } from "@angular/forms";
import { ICellRendererParams} from "@ag-grid-community/core";
import { Component, OnDestroy } from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { Subject } from "rxjs";
import { AmountInShipmentOutput } from "./amount-in-shipment.model";
import { AuthService } from "src/app/services/auth.service";
import { LoginModel } from "src/app/models/login.model";
import { MatSnackBar } from "@angular/material/snack-bar";

import { GridActionsService } from "src/app/data-grid/grid-actions.service";

import { PurchasingService } from "src/app/modules/planyard/purchasing.service";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";


@Component({
  selector: "app-amount-in-shipment-cell-renderer",
  templateUrl: "./amount-in-shipment-cell-renderer.component.html",
  styleUrls: ["./amount-in-shipment-cell-renderer.component.scss"],
})
export class AmountInShipmentCellRendererComponent implements OnDestroy {
  params: any;
  amount = new FormControl();
  amountInShipment;
  disableTooltip: boolean = true;
  private destroy$ = new Subject<void>();
  suggestedAmount;
  suggestedTooltip;
  user;
  roundedAmount:number=0;
  onlyShipyardUser:boolean=false;
  isQueued:boolean=false;
  loading: boolean=false;
  isShipmentQueue:boolean=false;
  isPurchasingQueue:boolean = false;
  constructor(
    public shipyardService: ShipyardService,
    private authService:AuthService,
    private snackbar: MatSnackBar,
    private gridActionsService:GridActionsService,
    private purchasingService:PurchasingService)
    {
      this.gridActionsService.updateRemainigDays$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
        let nodeData = res.node.data;
        let totalStock = (nodeData.ReplenishDays * res.value);
        let suggested = (totalStock - (nodeData?.FbaStock || 0) - 
                          ((nodeData?.AmountInShipment || 0) + (nodeData?.Working || 0)) + (this.roundedAmount || 0));
        if(res.value && this.params?.node === res?.node){
          this.suggestedAmount = Math.trunc(suggested);
        }
      })
      this.shipyardService.seasonalValueChanged.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
        if(res && this.params?.node === res?.node){
          if(res.amount){
            this.roundedAmount=res.enforceValue ? res.enforceValue : this.params.data[this.params.props] - this.params.data.Restock;            
            this.suggestedAmount=res.amount;
          } else{
            this.roundedAmount=this.params.data[this.params.props] - this.params.data.Restock;           
            this.suggestedAmount=this.params.data[this.params.props];
          }
          this.bindToolTip();
        }
      })

    this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res:LoginModel) => {
        this.onlyShipyardUser = (!res.isPlanYard  && !res.isPriceYard && !res.isYardener && (res.isShipyard != 0 || res.isShipyard != null));
      });
  }

  bindToolTip(){
    var a = this.roundedAmount  > 0 ? '+ ' : ''
    const value=Math.round((this.roundedAmount + Math.round(this.params.data.AmountDiffRepl)) / this.params.data.CaseQty)
    this.suggestedTooltip = 'Case QTY enforced ' + a + this.roundedAmount + "\n Cases: " + this.params.data.CaseQty; 
  }

  agInit(params: any): void {
    this.user = JSON.parse(localStorage.getItem("User"));
    this.params = params;
    if(params['isShipmentQueue']){
      this.isShipmentQueue=params['isShipmentQueue'];
    }else{
      this.isShipmentQueue= false;
    }
    if(params['isPurchasingQueue']){
      this.isPurchasingQueue = params['isPurchasingQueue'];
    }else{
      this.isPurchasingQueue = false;
    }
    this.setPreviousSelectionCount();
    this.amountInShipment = this.params.data.AmountInShipment + this.params.data.Working;
    if(params.props)
    this.suggestedAmount=params.data[params.props];
    this.roundedAmount=params.data[params.props] - this.params.data.Restock;
    this.bindToolTip();
    this.amount.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      if(e !== undefined && this.params.data.SelectedQty != e){
        this.params.data.SelectedQty = e;
        if (!this.isShipmentQueue  && !this.isPurchasingQueue) {
          this.amountChanged(e);
        }
          if (this.params.callbackFunction) {
            const output: AmountInShipmentOutput = {
              value: e,
              node: this.params.node
            }
            this.params.callbackFunction(output);
          }
      }    
    });
    if(this.isShipmentQueue || this.isPurchasingQueue){
      if(this.params.data?.QueueQty != null){
        this.amount.setValue(this.params.data?.QueueQty)
        if(this.isPurchasingQueue){
          let index = this.shipyardService.skusToAddToShipment.findIndex((res)=> res.sku.ItemId == this.params.data.ItemId);
          if(index == -1){
            this.shipyardService.skusToAddToShipment.push({qty:this.params.data.QueueQty,sku:this.params.data})
          }
        } 
      }
    }
    if (this.shipyardService.shipmentTypeToAddToShipment$) {
      this.shipyardService.shipmentTypeToAddToShipment$
        .pipe(takeUntil(this.destroy$))
        .subscribe((e) => {
          if (e === this.params.data.FbaType || !e) {
            this.amount.enable({ emitEvent: false });
            this.disableTooltip = true;
           } 
        });
    }
  }

  setPreviousSelectionCount() {
    const index = this.getIndexInArray();
    if (index !== -1) {
      const qty = this.shipyardService.skusToAddToShipment[index].qty;
      if (qty) {
        this.amount.setValue(qty);
      }
      this.params.node.setSelected(true);
    }
  }

  addAmountToShipment(e: MouseEvent, amount) {
    e?.stopPropagation();
    this.params.data.SuggestedQty = amount;     
    if (this.amount.value === amount) {
      this.amount.reset();
    } else {
      this.amount.setValue(amount);
    }
    if (this.params.callbackFunction) {
      const output: AmountInShipmentOutput = {
        value: this.amount.value,
        node: this.params.node
      }
      this.params.callbackFunction(output);
    }
    this.amountChanged(this.amount.value);
  }

  getIndexInArray() {
    if (this.params.data.ItemId) {
      return this.shipyardService.skusToAddToShipment
        .map((e) => e.sku?.ItemId)
        .indexOf(this.params.data.ItemId);
    } else if (this.params.data.AccountSkuId) {
      return this.shipyardService.skusToAddToShipment
        .map((e) => e.sku.AccountSkuId)
        .indexOf(this.params.data.AccountSkuId);
    }
  }

  inputClicked(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
  }

  amountChanged(e) {
    const obj = { sku: this.params.data, qty: e };
    const index = this.getIndexInArray();
   
    if (index === -1) {     
      if (e >= 1){
        this.shipyardService.skusToAddToShipment.push(obj);
        if (this.isShipmentQueue || this.isPurchasingQueue) this.selectedValueChanged(e);
      } 
    } else if (!e || e <= 0) {   
      this.shipyardService.skusToAddToShipment.splice(index, 1);
      if (this.isShipmentQueue || this.isPurchasingQueue) this.removeShipmentFromQUeue()
    } else {
      this.shipyardService.skusToAddToShipment[index].qty = e;
      if (this.isShipmentQueue || this.isPurchasingQueue) this.selectedValueChanged(e);
    }
    this.setShipmentType();
  }

  setShipmentType() {
    if (this.shipyardService.shipmentTypeToAddToShipment$) {
      if (!this.shipyardService.skusToAddToShipment.length) {
        this.shipyardService.shipmentTypeToAddToShipment$.next(undefined);
      } else if (this.shipyardService.skusToAddToShipment.length === 1) {
        this.shipyardService.shipmentTypeToAddToShipment$.next(
          this.params.data.FbaType
        );
      }
    }
  }

  public onlyNumberKey(event) {
    return event.charCode == 8 || event.charCode == 0
      ? null
      : event.charCode >= 48 && event.charCode <= 57;
  }

  refresh(params: ICellRendererParams) {
    this.amount.markAsTouched();
    this.params.data.SuggestedQty= params.data.SuggestedQty;
    this.amount.setValue(this.params.data.SuggestedQty);
    return true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  removeShipmentFromQUeue(){
    if(this.isShipmentQueue){
     this.RemoveShipmentQueue();
    }else{
     this.removePurchasingQueue();
    }    
  }

  RemoveShipmentQueue(){
    const payload={
      accountSkuIds:[
        this.params.data.AccountSkuId
      ]
    }
    this.shipyardService.RemoveShipmentQueue(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        this.shipyardService.updateQueueCount.next(true);
        this.isQueued=false;
      }, 
      error: (err) => {
        this.snackbar.open(err.error.error[0], "Dismiss", { duration: 3000 });
      }
  })
  }

  selectedValueChanged(e){
    this.loading = true;
    if(this.isShipmentQueue){
      if(e){
       this.createShipmentQueue(e)
      }
    }else{
      if(e){
       this.createPurchasingQueue(e);
      }
    }
  }

  createShipmentQueue(e){
      const payload={
        account:this.params.data.Account,
        skus:[{
          sku: this.params.data.Sku,
          qty: e,
          accountSkuId:this.params.data.AccountSkuId
        }]
      }
      this.shipyardService.CreateShipmentQueue(payload).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res:any) => {
          this.shipyardService.updateQueueCount.next(true);
        if(this.params.data.SelectedQty <= this.params.data.LocalStock){
          this.isQueued=true;
        } else {
          this.isQueued=false;
        }
        this.loading = false;
      }, 
        error: (err) => {
          this.snackbar.open(err.error?.error[0], "Dismiss", { duration: 3000 });
          this.loading = false;
        }
      }
      )
    }
  valueChange(event){
    if (this.isShipmentQueue || this.isPurchasingQueue) {
      if (this.params.callback) {
        const output: AmountInShipmentOutput = {
          value: event.target.value,
          node: this.params.node
        }
        this.params.callback(output);
      }
      this.amountChanged(Number(event.target.value));
    }
  }

  removePurchasingQueue(){
    const payload={
      removeSku: [
        {
          itemId: this.params.data.ItemId,
          accountSkuId: null
        }
      ]
    }
    this.shipyardService.purchasingQueueCount -= 1;
    this.purchasingService.RemovePurchasingQueue(payload).pipe(takeUntil(this.destroy$))
    .subscribe({
      next:(res)=>{
        this.purchasingService.updatePurchasingQueueCount.next(true);
      },
      error:(err)=>{
        this.snackbar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
    })
  }

  createPurchasingQueue(e){
    const payload={
      skus:[{
        qty: e,
        accountSkuId:0,
        itemId:this.params.data.ItemId
      }]
    }
    this.shipyardService.purchasingQueueCount += 1;
    this.purchasingService.createPurchasingQueue(payload).subscribe({
      next:(res:any)=>{       
        this.purchasingService.updatePurchasingQueueCount.next(true);
        this.loading = false;
      },
      error:(err)=>{
        this.snackbar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
        this.loading = false;
      }
    })
  }
}



